import React from "react";
import { ReferenceLine } from "recharts";
import {
  PROJECT_END_MARKER_COLOR,
  PROJECT_END_MARKER_LABEL,
  type ReferenceLineLabelPlacement,
} from "../../utils/chart/chart-period.utils";

interface ProjectEndReferenceLineProps {
  periodLabel: string;
  labelPlacement?: ReferenceLineLabelPlacement;
}

const ProjectEndReferenceLine: React.FC<ProjectEndReferenceLineProps> = ({
  periodLabel,
  labelPlacement = { position: "top" },
}) => (
  <ReferenceLine
    x={periodLabel}
    stroke={PROJECT_END_MARKER_COLOR}
    strokeWidth={2}
    strokeDasharray="4 4"
    label={{
      value: PROJECT_END_MARKER_LABEL,
      position: labelPlacement.position,
      dy: labelPlacement.dy,
      fill: PROJECT_END_MARKER_COLOR,
      fontSize: 10,
      fontWeight: 700,
    }}
  />
);

export default ProjectEndReferenceLine;
